import * as actions from "@/store/action-types";
import { getActiveOrganisationWallet, getUserOrganisations } from "@/lib/utils";

export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user.user;
    },
    organisation() {
      return this.$store.getters.organisation.summary;
    },
    organisations() {
      const organisations = this.$store.getters.organisations;

      return organisations.length && this.organisation
        ? organisations.filter(
            organisation =>
              organisation.organisation_id !== this.organisation.id
          )
        : [];
    }
  },
  created() {
    const { disableSwitch } = this.$route.params;

    if (this.organisation) {
      this.getOrganisations();

      if (!disableSwitch) {
        this.getActiveOrganisationPermissions();
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(actions.LOGOUT).then(() => {
        this.$router.push({ name: "login" });
      });
    },
    setOrganisation(data) {
      this.$store.dispatch(actions.ORGANISATION, {
        summary: data.organisation,
        features: data.features,
        permissions: data.permissions,
        is_owner:
          data.organisation_account_user &&
          data.organisation_account_user.is_owner
      });
    },
    async getOrganisations() {
      this.loading = true;
      try {
        const response = await getUserOrganisations(this.$http);
        if (response.data.status === "error") {
          this.handleErrors(response.data);
        }
      } catch {
        this.notification(
          "Error",
          "Unable to update list of organisations",
          "danger"
        );
      } finally {
        this.loading = false;
      }
    },
    getWallet() {
      if (!this.userCan("payment", "wallet.getall")) {
        return;
      }
      getActiveOrganisationWallet(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    getActiveOrganisationPermissions() {
      this.switchToOrganisation(this.organisation.id)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.setOrganisation(resData);

            if (this.userCan("payment", "wallet.getall")) {
              this.getWallet();
            }
          }
        })
        .catch();
    },
    switchOrganisation(id) {
      const loading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "dark"
      });

      if (this.$refs.popover) {
        this.$refs.popover.doClose();
      }

      this.switchToOrganisation(id)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.$router.push({ name: "home.index" });
            this.setOrganisation(resData);

            if (this.userCan("payment", "wallet.getall")) {
              this.getWallet();
            }
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    switchToOrganisation(organisationId) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(`organisations/${organisationId}/switch`, {
            method: "POST"
          })
          .then(response => {
            this.$store.dispatch(actions.SWITCH_KEY, new Date().getTime());
            resolve(response);
          })
          .catch(error => {
            this.notification("Error", "An unknown error occurred", "danger");
            reject(error);
          });
      });
    }
  }
};
